import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createGameTableService,
  deleteGameTableService,
  getAllGameTablesService,
  getGameTableDetailsService,
  updateGameTableService
} from 'network/services/gameTable.service'

export const fetchAllGameTables = createAsyncThunk(
  'fetch/allGameTables',
  async (data, thunkApi) => {
    try {
      const res = await getAllGameTablesService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchGameTableDetails = createAsyncThunk(
  'fetch/gameTableDetails',
  async (tableId, thunkApi) => {
    try {
      const res = await getGameTableDetailsService(tableId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const createGameTable = createAsyncThunk(
  'create/gameTable',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await createGameTableService(data)
      onSuccess?.()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const updateGameTable = createAsyncThunk(
  'update/gameTable',
  async ({ data, onSuccess, onComplete }, thunkApi) => {
    try {
      const res = await updateGameTableService(data)
      onSuccess?.()
      onComplete?.()
      return res
    } catch (error) {
      onComplete?.()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const deleteGameTable = createAsyncThunk(
  'delete/gameTable',
  async ({ tableId, onSuccess, onComplete }, thunkApi) => {
    try {
      const res = await deleteGameTableService(tableId)
      onSuccess?.()
      onComplete?.()
      return res
    } catch (error) {
      onComplete?.()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
